import { Container, Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import messages from 'components/Footer/messages';
import {
  FbStyledIncon,
  FooterText,
  FooterWrapper,
  StyledAllRightResevedText,
  StyledImg,
  StyledShortBody,
  StyledTag,
} from 'components/Footer/styles';
import {
  CONTACT_US_LINK,
  FACEBOOK_LINK,
  YOUTUBE_LINK,
} from 'constants/externalLinks';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { isReverse } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import React from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import PAGES from 'routes/pages';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const Footer = (props: { intl: IntlShape }) => {
  const language = useSelector(getLocaleSelector);
  const reverse = isReverse(language);
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const direction = matches ? 'column-reverse' : 'row';
  const justify = matches ? 'center' : 'space-between';
  return (
    <FooterWrapper>
      <Container>
        <Grid
          container
          justify={justify}
          direction={direction}
          spacing={matches ? 2 : undefined}
          alignItems="center"
        >
          <Grid item>
            <StyledAllRightResevedText>
              {formatMessage(messages.allRightsReserved, {
                year: new Date().getFullYear(),
              })}
            </StyledAllRightResevedText>
          </Grid>
          <Grid item xs={matches ? 8 : 6}>
            <Grid container justify={justify} spacing={matches ? 2 : undefined}>
              <Grid item>
                <GaClickHOC
                  category={EVENT_CATEGORIES.LEGAL_NOTICE}
                  label="Mentions légales"
                >
                  <StyledShortBody
                    onClick={() => {
                      pushTo(PAGES.LEGAL_NOTICE);
                    }}
                  >
                    {formatMessage(messages.legalNotice)}
                  </StyledShortBody>
                </GaClickHOC>
              </Grid>
              <Grid item>
                <FooterText
                  onClick={() => {
                    pushTo(PAGES.SITEMAP);
                  }}
                >
                  {formatMessage(messages.sitemap)}
                </FooterText>
              </Grid>
              <Grid item>
                <GaClickHOC category={EVENT_CATEGORIES.LEXIQUE} label="Lexique">
                  <FooterText
                    onClick={() => {
                      pushTo(PAGES.LEXIQUE);
                    }}
                  >
                    {formatMessage(messages.lexique)}
                  </FooterText>
                </GaClickHOC>
              </Grid>
              <Grid item>
                <FooterText
                  onClick={() => {
                    pushTo(PAGES.FAQ);
                  }}
                >
                  {formatMessage(messages.faq)}
                </FooterText>
              </Grid>
              <Grid item>
                <GaClickHOC
                  category={EVENT_CATEGORIES.CONTACT_US}
                  label="Page Contact SanlamAllianz"
                >
                  <StyledTag href={CONTACT_US_LINK[language]} target="_blank">
                    <FooterText>{formatMessage(messages.contactUs)}</FooterText>
                  </StyledTag>
                </GaClickHOC>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container>
              <GaClickHOC category={EVENT_CATEGORIES.FACEBOOK} label="Facebook">
                <StyledTag href={FACEBOOK_LINK} target="_blank">
                  <FbStyledIncon
                    reverse={reverse}
                    src={get(AssuranceIcon, 'facebookIcon')}
                    alt="facebook-icon"
                  />
                </StyledTag>
              </GaClickHOC>
              <GaClickHOC category={EVENT_CATEGORIES.YOUTUBE} label="Youtube">
                <StyledTag href={YOUTUBE_LINK} target="_blank">
                  <StyledImg
                    src={get(AssuranceIcon, 'youtubeIcon')}
                    alt="youtube-icon"
                  />
                </StyledTag>
              </GaClickHOC>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </FooterWrapper>
  );
};

export default injectIntl(Footer);
